import React from 'react';
import { StaticQuery, graphql } from "gatsby"
import './styles.scss'

const MobileAccomplishment = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                mobilelp {
                  webGrowth {
                    title
                    growthImgAlt
                  }
                }
                language
              }
            }
          }
          webGrowthEnGraph: file(relativePath: {eq: "mobilelp/accomplishment/autify-web-growth_en.svg"}) {
            name
            publicURL
          }
          webGrowthJaGraph: file(relativePath: {eq: "mobilelp/accomplishment/autify-web-growth_ja.svg"}) {
            name
            publicURL
          }
          webGrowthJaGraphSp: file(relativePath: {eq: "mobilelp/accomplishment/autify-web-growth-sp_ja.svg"}) {
            name
            publicURL
          }
          webGrowthEnGraphSp: file(relativePath: {eq: "mobilelp/accomplishment/autify-web-growth-sp_en.svg"}) {
            name
            publicURL
          }
        }
      `}
      render={({ allDataYaml: { edges}, webGrowthEnGraph, webGrowthJaGraph, webGrowthEnGraphSp, webGrowthJaGraphSp }) => {
        const { language } = props
        const { node: { mobilelp: { webGrowth } } } = edges.find(({node}) => node.language === props.language)
        const webGrowthGraph = language === "ja" ? webGrowthJaGraph : webGrowthEnGraph;
        const webGrowthGraphSp = language === "ja" ? webGrowthJaGraphSp : webGrowthEnGraphSp;

        return <div className="mobile-accomplishment">
          <h2 className="mobile-accomplishment-heading text-center">{webGrowth.title}</h2>
          <div className="container">
            <div className="mt-5 d-none d-md-block">
              <img src={webGrowthGraph.publicURL} className="w-100" loading="lazy" decoding="async" alt={webGrowth.growthImgAlt}/>
            </div>
            <div className="mt-5 w-100 d-block d-md-none">
              <img src={webGrowthGraphSp.publicURL} className="w-100" loading="lazy" decoding="async" alt={webGrowth.growthImgAlt}/>
            </div>
          </div>
        </div>
      }}
    />
  )
}

export default MobileAccomplishment;
